module.exports = __webpack_public_path__ + "static/media/NI.bba6620b.png";